const navHighlighter = () => {
    let scrollY = window.pageYOffset;

    document.querySelectorAll(".content-section[id]").forEach((current, index) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 50;
        const sectionId = current.getAttribute("id");
        const navigationItem = document.querySelector(`a[href="#${sectionId}"]`);

        if (!navigationItem) return;

        if ((scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) || (scrollY < sectionTop && index === 0)) {
            navigationItem.parentElement.classList.add("organization-navigation__item-active");
        } else {
            navigationItem.parentElement.classList.remove("organization-navigation__item-active");
        }
    });
};

window.addEventListener("scroll", navHighlighter);
